import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgSorry: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 255 285" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
    <defs>
      <path id="id3311389187__a" d="M.22.43h211.93v207.3H.22z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M214.91 116.62S245.53 190 216.8 194c0 0-10.74-.71-8.22-12.16 0 0-11.85-3.27-7.11-13.5 0 0-12.88-.8-12.22-15.51 0 0 .23-14.1 12-30.23 0 0 9.02-9.49 13.67-5.97M12 122.94s-27.51 67.07.78 71.94c0 0 10.51-.22 7.65-10.98 0 0 11.5-2.57 6.5-12.29 0 0 12.6-.21 11.45-13.94 0 0-.7-13.14-12.79-28.63 0 0-9.15-9.19-13.6-6.1"
        fill="#FF7300"
      />
      <g transform="translate(10 28.57)">
        <mask id="id3311389187__b" fill="#fff">
          <use xlinkHref="#id3311389187__a" />
        </mask>
        <path
          d="M199.96 57.08c-1.47-3.38-3.53-9.12-4.54-12.69l-9.1-32.2c-1.01-3.56-4.65-5.34-8.16-3.9l-10.88 4.53c-3.52 1.44-9.06 1.32-12.49-.14 0 0-25.7-11.29-44.13-12.2-19.68-.9-48.21 9.85-48.21 9.85-3.5 1.3-9.13 1.02-12.53-.57l-10.33-4.8c-3.4-1.6-7.08-.05-8.3 3.57l-10 29.9c-1.2 3.48-3.55 9.07-5.27 12.44 0 0-14.78 28.27-15.7 48.64-2.44 57.16 42.96 105.5 101.46 108.1 58.38 2.58 107.87-41.73 110.31-98.89 1-21.32-12.13-51.64-12.13-51.64"
          fill="#FF7300"
          mask="url(#id3311389187__b)"
        />
        <path
          d="M18.91 162.63c18.25 25.9 48.27 43.45 82.87 44.98 14.52.65 30.22-.95 43.68-6.45 19.84-8.1 36.23-23.05 48.32-38.53 6.26-8-21.43 38.53-87.28 38.53s-93.99-47.6-87.59-38.53z"
          fill="#D85700"
          mask="url(#id3311389187__b)"
        />
      </g>
      <path
        d="M44.85 132.34c-3.49 18.67 8.82 36.62 27.5 40.1 18.66 3.5 36.62-8.82 40.1-27.49 3.49-18.67-8.82-36.63-27.5-40.11-18.66-3.48-36.62 8.83-40.1 27.5"
        fill="#D85700"
      />
      <path
        d="M43.53 135.27c-3.48 18.67 8.83 36.63 27.5 40.11 18.67 3.49 36.63-8.83 40.1-27.5 3.5-18.66-8.82-36.62-27.49-40.1-18.67-3.49-36.62 8.82-40.1 27.49"
        fill="#FFF"
      />
      <path
        d="M125.85 132.34c-3.49 18.67 8.82 36.62 27.5 40.1 18.66 3.5 36.62-8.82 40.1-27.49 3.49-18.67-8.82-36.63-27.5-40.11-18.66-3.48-36.62 8.83-40.1 27.5"
        fill="#D85700"
      />
      <path
        d="M124.53 135.27c-3.48 18.67 8.83 36.63 27.5 40.11 18.67 3.49 36.63-8.83 40.1-27.5 3.5-18.66-8.82-36.62-27.49-40.1-18.67-3.49-36.62 8.82-40.1 27.49"
        fill="#FFF"
      />
      <path
        d="M188.55 276.24c0-6.87-31.91-13.24-71.28-13.24C77.91 263 46 268.27 46 275.14c0 6.87 31.91 9.65 71.27 9.65 39.37 0 71.28-1.68 71.28-8.55z"
        fill="#000"
        fillRule="nonzero"
        opacity={0.28}
      />
      <g fillRule="nonzero">
        <path
          d="M117.06 192.62c0-.77-16.86-5.96-20.96-6.62-.27.35-.94 1.55 13.1 11.84.45.4 3.22 2.12 8.3 5.16 8.67-7.22 14.91-11.64 18.72-13.26 3.56-1.51 2.75-1.86 2.6-2.16.08-1.54-8.28.77-14.76 2.78-3.21 1-5.96 1.92-7 2.26z"
          fill="#D85700"
        />
        <path
          d="M117.5 187.46c0-.53-6.38 1.98-19.27-.88-2.34-.83-2.84-.77-1.5.19 1.82 1.3 5.19 3.51 10.12 6.67.46.41 4.03 1.93 10.71 4.56 10.35-5.35 17.44-8.87 21.3-10.54.21-.26.16-.57 0-.88 0 0-18.2-.2-21.36.88z"
          fill="#F2F2F2"
        />
        <path
          d="M134.53 185.52c.42-.64-16.33-16-17.45-16.5-.74-.33-6.25 4.28-16.53 13.85L96 186.48c.86.76 2.23 1.54 4.11 2.34 6.85 2.12 12.42 3.18 16.71 3.18 4.3 0 9.7-1.18 16.24-3.54 3.26-.83 5.24-1.25 5.94-1.25l-4.47-1.7z"
          fill="#B8B8B8"
        />
        <path
          d="M117.26 168.02c-.74-.33-6.2 4.2-16.4 13.61L95 186.78c1.37 1.19 8.76 2.26 22.17 3.22 14.1-1.8 21.39-2.71 21.83-2.71-13.75-12.53-21-18.95-21.74-19.27z"
          fill="#FFF"
        />
      </g>
      <path fill="#D85700" d="M57 100.86l-1.64-3.18L93.98 81v7.38zM176.67 100.86l1.74-2.82-38.72-15.99v6.33z" />
      <rect fill="#404040" transform="rotate(29 82.53 136.64)" x={67.03} y={134.64} width={31} height={4} rx={2} />
      <rect fill="#404040" transform="rotate(-24 83 148.99)" x={68.5} y={146.99} width={29} height={4} rx={2} />
      <rect
        fill="#404040"
        transform="scale(-1 1) rotate(29 0 -455.16)"
        x={137.55}
        y={134.64}
        width={31}
        height={4}
        rx={2}
      />
      <rect
        fill="#404040"
        transform="scale(-1 1) rotate(-24 0 869.22)"
        x={138.13}
        y={146.79}
        width={30}
        height={4}
        rx={2}
      />
      <g>
        <path
          d="M242 86.58c-4.53 1.84-15.34 15.92-15.34 15.92s17.62 2.57 22.14.75c4.52-1.82 6.67-7.05 4.79-11.65-1.88-4.6-7.07-6.86-11.6-5.02z"
          fill="#5EC0FF"
          fillRule="nonzero"
        />
        <path
          d="M246 90.62s1.31.14 3.27 1.5"
          stroke="#FFF"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M248.56 118.56c-3.5-.73-15.86 3.35-15.86 3.35s9.66 8.68 13.16 9.42c3.5.74 6.95-1.53 7.7-5.05.74-3.52-1.49-7-5-7.72z"
          fill="#5EC0FF"
          fillRule="nonzero"
        />
        <path
          d="M248.44 121.83s.99.13 2.52 1.28"
          stroke="#FFF"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M137.83 20.35C125.73 6.8 98.8 17.49 97.2 18.14l-.08.03c24.4-19 40.07 1.33 40.7 2.15zm1.71-8.05C127.08-1.67 99.98 8.04 99.98 8.05c24.88-19.39 39.56 4.25 39.56 4.25z"
        fill="#B8B8B8"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgSorry;
